import { httpCore } from "../../config/http";
import { versionPcm } from "../../config/Versions";
import { Pcm } from "../../config/Paths";
import { changeLoading } from "./loading.action";
import { changeNotify } from "./notify.action";


export const actionTypes = {
  INDEX: "PCM_INDEX",
  SHOW: "PCM_SHOW",
  DESTROY: "PCM_DESTROY",
  CHANGE: "PCM_CHANGE",
  SUCCESS: "PCM_SUCCESS",
  ERROR: "PCM_ERROR",
};

export const change = (payLoad) => ({
  type: actionTypes.CHANGE,
  payLoad,
});

export const success = (payLoad) => ({
  type: actionTypes.SUCCESS,
  payLoad,
});

export const error = (payLoad) => ({
  type: actionTypes.ERROR,
  payLoad,
});

//INDEX
export const indexResponse = (payLoad) => ({
  type: actionTypes.INDEX,
  payLoad,
});

export const index = () => (dispatch) => {
  return httpCore
    .get(versionPcm + Pcm)
    .then(function (res) {
      if (res.response !== "undefined") {
        if (res.request.status === 200) {
          dispatch(indexResponse(res.data.data));
          return res.data.data;
        }
      }
    })
    .catch((error) => {
      // Error
      if (error.response) {
        //A solicitação foi feita e o servidor respondeu com um código de status fora do intervalo 2XX
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        //  A solicitação foi feita, mas nenhuma resposta foi recebida
        console.log(error.request);
      } else {
        // Algo aconteceu na configuração da solicitação que acionou um erro
        console.log("Error", error.message);
      }
      console.log(error.config);
      dispatch(
        changeNotify({
          open: true,
          class: "error",
          msg: "Erro ao carregar depósitos",
        })
      );
    });
};

//STORE
export const store = (pcm) => (dispatch) => {
  return httpCore
    .post(versionPcm + Pcm, {
      descricao: pcm["descricao"],
      endereco: pcm["endereco"],
      cep: pcm['cep'],
      numero: pcm["numero"],
      estadoId: pcm["estadoId"],
      cidadeId: pcm["cidadeId"],
      bairroId: pcm["bairroId"],
      complemento: pcm["complemento"],
      ativo: pcm["ativo"],
      horariosDisponiveis: pcm["horariosDisponiveis"],
    })
    .then((res) => {
      if (typeof res !== "undefined") {
        console.log(res);
        if (res.status === 200 || res.status === 201) {
          dispatch(
            changeNotify({
              open: true,
              class: "success",
              msg: pcm["descricao"] + " cadastrado com sucesso",
            })
          );
          dispatch(index());
        }
      }
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 404 || error.response.status === 400) {
          dispatch(
            changeLoading({
              open: false,
            })
          );
          dispatch(
            changeNotify({
              open: true,
              class: "error",
              msg: "Erro ao cadastrar o Pcm",
            })
          );
        }
      } else if (error.request) {
        //  A solicitação foi feita, mas nenhuma resposta foi recebida
        dispatch(
          changeLoading({
            open: false,
          })
        );
        dispatch(
          changeNotify({
            open: true,
            class: "error",
            msg: "Sem resposta do servidor",
          })
        );
        dispatch(index());
        console.log(error.request);
      } else {
        // Algo aconteceu na configuração da solicitação que acionou um erro
        console.log("Error", error.message);
        dispatch(
          changeNotify({
            open: true,
            class: "error",
            msg: "Erro ao salvar depósito",
          })
        );
      }
      // console.log(error.config);
    });
};

//UPDATE
export const update = (data) => (dispatch) => {
  dispatch(
    changeLoading({
      open: true,
      msg: "Alterando...",
    })
  );
  return httpCore
    .put(versionPcm + Pcm + data.id, data)
    .then((res) => {
      dispatch(
        changeLoading({
          open: false,
        })
      );
      if (res !== "undefined") {
        if (res.status === 200 || res.status === 201) {
          dispatch(
            changeNotify({
              open: true,
              class: "success",
              msg: "Alterado com sucesso",
            })
          );
        }
        dispatch(index());
      }
    })
    .catch((erro) => {
      dispatch(
        changeNotify({
          open: true,
          class: "error",
          msg: "Erro ao salvar depósito",
        })
      );
    });
};

//DESTROY
export const destroyResponse = (payLoad) => ({
  type: actionTypes.DESTROY,
  payLoad,
});

export const destroy = (id) => (dispatch) => {
  dispatch(
    changeLoading({
      open: true,
      msg: "Deletando...",
    })
  );
  return httpCore
    .delete(versionPcm + Pcm + id)
    .then((res) => {
      if (res !== "undefined") {
        if (res.status === 200) {
          dispatch(
            changeLoading({
              open: false,
            })
          );
          dispatch(
            changeNotify({
              open: true,
              class: "success",
              msg: "Excluido com Sucesso",
            })
          );
          dispatch(destroyResponse(id));
        }
        dispatch(index());
      }
    })
    .catch((error) => {
      // Error
      if (error.response) {
        //A solicitação foi feita e o servidor respondeu com um código de status fora do intervalo 2XX
        if (error.response.status === 404) {
          dispatch(
            changeLoading({
              open: false,
            })
          );
          dispatch(
            changeNotify({
              open: true,
              class: "error",
              msg: "Tipo de veículo não encontrado",
            })
          );
        }
      } else if (error.request) {
        //  A solicitação foi feita, mas nenhuma resposta foi recebida
        dispatch(
          changeLoading({
            open: false,
          })
        );
        dispatch(
          changeNotify({
            open: true,
            class: "error",
            msg: "Sem resposta do servidor",
          })
        );
        dispatch(index());
        console.log(error.request);
      } else {
        // Algo aconteceu na configuração da solicitação que acionou um erro
        console.log("Error", error.message);
        dispatch(
          changeNotify({
            open: true,
            class: "error",
            msg: "Erro ao remover depósito",
          })
        );
      }
      // console.log(error.config);
    });
};
